import Ajv from "ajv";
import GUIDEDSELLING_AI from '../../node_modules/guidedselling-ai/package.json';

const ajv = new Ajv({
  useDefaults: true,
  allErrors: true,
  jsonPointers: true
});

class ValidationService {
  validators = {}

  init = () => {
    if(GUIDEDSELLING_AI["app-framework"] && GUIDEDSELLING_AI["app-framework"]["actions"]) {
      this.validators = {
        ...this.validators,
        ...Object.fromEntries(Object.entries(GUIDEDSELLING_AI["app-framework"]["actions"])
        .map(([name, value]) => [`@guidedselling-ai/${name}`, ajv.compile(value)]))
      };
    }
  };

  validateable = (action) => this.validators[action.type]

  validate = async (action) => this.validators[action.type](action.payload)
}

const inst = new ValidationService();
inst.init();
export default inst;
